module.exports = __webpack_public_path__ + "static/media/ArchivedFolderWithFiles.9e521f37.svg";